import React, { Component } from "react";
import { Box, Fab } from "@material-ui/core";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { bindActionCreators } from "redux";
import { withHistory, historyPush, formatMessage, Helmet, clearCurrentPaginationPage } from "@openimis/fe-core";

import ProjectForm from "../components/ProjectForm";
import { fetchAccreditation } from "../actions";
import isEqual from "lodash/isEqual";
import { ACCREDITATION } from "../constants";

const styles = (theme) => ({
  page: theme.page,
  fab: theme.fab,
});

class AccreditationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edited: {},
    };
  }

  componentDidMount() {
    const projectUuid = this.props?.match?.params?.projectUuid;
    if (projectUuid) {
      // If projectUuid exists, fetch the quality_assurance_and_accreditation data
      this.props.fetchAccreditation(projectUuid);
    }
  }

  componentDidUpdate(prevProps) {
    const { accreditation } = this.props;
    // Check if accreditation data has changed and is different from the current state
    if (accreditation && !isEqual(accreditation, prevProps.accreditation)) {
      this.setState({
        edited: { ...accreditation },
      });
    }
  }

  handleChange = (name, value) => {
    this.setState((prevState) => ({
      edited: {
        ...prevState.edited,
        [name]: value,
      },
    }));
  };

  onAdd = () => {
    const { modulesManager, history } = this.props;
    if (modulesManager && history) {
      historyPush(modulesManager, history, "accreditation.route.details");
    }
  };
  render() {
    const { intl, accreditation, fetchedAccreditation } = this.props;
    const projectUuid = this.props?.match?.params?.projectUuid;
    const projectId = accreditation ? accreditation[0].id : null;

    return (
      <div className={""}>
        <Helmet title={formatMessage(intl, "quality_assurance_and_accreditation", "projects.page.title")} />
        {(!projectUuid || fetchedAccreditation) && (
          <ProjectForm
            edited={this.state.edited}
            updateAttribute={this.handleChange}
            projectUuid={projectUuid}
            projectId={projectId}
            type={ACCREDITATION}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
  module: state.core?.savedPagination?.module,
  accreditation: state.quality_assurance_and_accreditation.accreditation,
  fetchingAccreditation: state.quality_assurance_and_accreditation.fetchingAccreditation,
  fetchedAccreditation: state.quality_assurance_and_accreditation.fetchedAccreditation,
  errorAccreditation: state.quality_assurance_and_accreditation.errorAccreditation,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ clearCurrentPaginationPage, fetchAccreditation }, dispatch);

export default injectIntl(
  withTheme(withStyles(styles)(withHistory(connect(mapStateToProps, mapDispatchToProps)(AccreditationPage)))),
);
